// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --awl-primary: #01978d;
  --awl-secondary: #007bff;
  --text-dark: #1f2937;
  --text-light: #6b7280;
  --bg-main: #f3f4f6;
  --bg-card: #ffffff;
  --border-color: #e5e7eb;
  --disabled: #e5e7eb;
  --disabled-text: #9ca3af;
}

.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
}

.app-name-header {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--text-dark);
  margin: 0;
}

.app-name-highlight {
  color: var(--awl-primary);
}

.company-logo-header {
  height: 28px;
  width: auto;
}

.insight-page {
  background-color: var(--bg-main);
  padding: 1rem;
  padding-bottom: 1rem;
}

.page-intro {
  text-align: center;
  margin-bottom: 0.75rem;
  animation: fadeInDown 0.5s ease-out;
}

.page-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-dark);
}

.page-subtitle {
  font-size: 0.9rem;
  color: var(--text-light);
  margin-top: 0.25rem;
}

.insight-form-card {
  background-color: var(--bg-card);
  padding: 1.25rem;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--border-color);
}

.form-step {
  margin-bottom: 0.5rem;
  animation: fadeInUp 0.6s ease-out forwards;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.step-number {
  width: 2rem;
  height: 2rem;
  background-color: var(--awl-primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.step-header h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-dark);
}

.form-group {
  margin-bottom: 0.5rem;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-group label {
  display: block;
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  color: var(--text-dark);
}

.form-group .required {
  color: #ef4444;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  border: 1px solid var(--border-color);
  background-color: #f9fafb;
  border-radius: 0.5rem;
  padding: 0.75rem;
  font-size: 1rem;
  font-family: "Inter", sans-serif;
  transition: all 0.2s ease-in-out;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--awl-primary);
  background-color: white;
  box-shadow: 0 0 0 3px rgba(1, 151, 141, 0.15);
}

.attachment-info {
  font-size: 0.8rem;
  color: var(--text-light);
  margin-bottom: 1rem;
}

.capture-buttons {
  display: flex;
  justify-content: space-around;
  gap: 1rem;
}

.capture-btn {
  width: 8rem;
  height: 8rem;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid var(--border-color);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.2s ease-in-out;
}

.capture-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  border-color: var(--awl-primary);
}

.capture-btn .icon {
  color: var(--awl-primary);
}

.capture-btn .icon svg {
  display: block;
}

.capture-btn span {
  font-weight: 500;
  color: var(--text-dark);
}

.preview {
  margin-top: 1.5rem;
  border-radius: 0.75rem;
  overflow: hidden;
  border: 1px solid var(--border-color);
  width: 100%;
  aspect-ratio: 16 / 9;
  background-color: #f9fafb;
}

.preview img,
.preview video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.submit-wrapper {
  position: relative;
}

.submit-btn {
  width: 100%;
  background: var(--awl-primary);
  color: white;
  padding: 0.9rem 1rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  margin-top: 0.5rem;
  transition: all 0.2s ease;
}

.submit-btn:hover:not(:disabled) {
  background: #017c73;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.submit-btn:disabled {
  background: var(--disabled);
  color: var(--disabled-text);
  cursor: not-allowed;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal-content {
  position: relative;
  background: white;
  border-radius: 0.75rem;
  padding: 2rem 1.5rem;
  width: 100%;
  max-width: 22rem;
  text-align: center;
}

.close-modal-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  background: none;
  border: none;
  font-size: 1.75rem;
  color: #9ca3af;
  cursor: pointer;
}

.modal-content h2 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.modal-content p {
  color: #6b7280;
  margin-bottom: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/MarketInsight.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,qCAAqC;EACrC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;;;EAGE,aAAa;EACb,gCAAgC;EAChC,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":[":root {\n  --awl-primary: #01978d;\n  --awl-secondary: #007bff;\n  --text-dark: #1f2937;\n  --text-light: #6b7280;\n  --bg-main: #f3f4f6;\n  --bg-card: #ffffff;\n  --border-color: #e5e7eb;\n  --disabled: #e5e7eb;\n  --disabled-text: #9ca3af;\n}\n\n.app-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  background-color: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.app-name-header {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--text-dark);\n  margin: 0;\n}\n\n.app-name-highlight {\n  color: var(--awl-primary);\n}\n\n.company-logo-header {\n  height: 28px;\n  width: auto;\n}\n\n.insight-page {\n  background-color: var(--bg-main);\n  padding: 1rem;\n  padding-bottom: 1rem;\n}\n\n.page-intro {\n  text-align: center;\n  margin-bottom: 0.75rem;\n  animation: fadeInDown 0.5s ease-out;\n}\n\n.page-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-dark);\n}\n\n.page-subtitle {\n  font-size: 0.9rem;\n  color: var(--text-light);\n  margin-top: 0.25rem;\n}\n\n.insight-form-card {\n  background-color: var(--bg-card);\n  padding: 1.25rem;\n  border-radius: 1rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid var(--border-color);\n}\n\n.form-step {\n  margin-bottom: 0.5rem;\n  animation: fadeInUp 0.6s ease-out forwards;\n}\n\n.step-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.step-number {\n  width: 2rem;\n  height: 2rem;\n  background-color: var(--awl-primary);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n}\n\n.step-header h4 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--text-dark);\n}\n\n.form-group {\n  margin-bottom: 0.5rem;\n}\n\n.form-group:last-child {\n  margin-bottom: 0;\n}\n\n.form-group label {\n  display: block;\n  font-weight: 600;\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n  color: var(--text-dark);\n}\n\n.form-group .required {\n  color: #ef4444;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  border: 1px solid var(--border-color);\n  background-color: #f9fafb;\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  font-size: 1rem;\n  font-family: \"Inter\", sans-serif;\n  transition: all 0.2s ease-in-out;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--awl-primary);\n  background-color: white;\n  box-shadow: 0 0 0 3px rgba(1, 151, 141, 0.15);\n}\n\n.attachment-info {\n  font-size: 0.8rem;\n  color: var(--text-light);\n  margin-bottom: 1rem;\n}\n\n.capture-buttons {\n  display: flex;\n  justify-content: space-around;\n  gap: 1rem;\n}\n\n.capture-btn {\n  width: 8rem;\n  height: 8rem;\n  border-radius: 50%;\n  background: #ffffff;\n  border: 1px solid var(--border-color);\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  transition: all 0.2s ease-in-out;\n}\n\n.capture-btn:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);\n  border-color: var(--awl-primary);\n}\n\n.capture-btn .icon {\n  color: var(--awl-primary);\n}\n\n.capture-btn .icon svg {\n  display: block;\n}\n\n.capture-btn span {\n  font-weight: 500;\n  color: var(--text-dark);\n}\n\n.preview {\n  margin-top: 1.5rem;\n  border-radius: 0.75rem;\n  overflow: hidden;\n  border: 1px solid var(--border-color);\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  background-color: #f9fafb;\n}\n\n.preview img,\n.preview video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.submit-wrapper {\n  position: relative;\n}\n\n.submit-btn {\n  width: 100%;\n  background: var(--awl-primary);\n  color: white;\n  padding: 0.9rem 1rem;\n  border-radius: 9999px;\n  font-weight: 600;\n  font-size: 1rem;\n  border: none;\n  cursor: pointer;\n  margin-top: 0.5rem;\n  transition: all 0.2s ease;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background: #017c73;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.submit-btn:disabled {\n  background: var(--disabled);\n  color: var(--disabled-text);\n  cursor: not-allowed;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modal {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n}\n\n.modal-content {\n  position: relative;\n  background: white;\n  border-radius: 0.75rem;\n  padding: 2rem 1.5rem;\n  width: 100%;\n  max-width: 22rem;\n  text-align: center;\n}\n\n.close-modal-btn {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.75rem;\n  background: none;\n  border: none;\n  font-size: 1.75rem;\n  color: #9ca3af;\n  cursor: pointer;\n}\n\n.modal-content h2 {\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.modal-content p {\n  color: #6b7280;\n  margin-bottom: 1.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
